import { motion } from "framer-motion";
import { GraduationCap, Users } from "lucide-react";

const audiences = [
  {
    key: "teachers",
    icon: GraduationCap,
    label: "For Teachers",
    title: "Guide students in seconds.",
    body: "A tool to guide students in seconds — no more improvising phonetic breakdowns on the fly.",
  },
  {
    key: "learners",
    icon: Users,
    label: "For Learners",
    title: "Build muscle memory, fast.",
    body: "The fastest way to explore and build muscle memory for every hard-to-pronounce word.",
  },
];

export const AudienceSplit = () => {
  return (
    <section
      data-testid="audience-split-section"
      className="relative w-full px-4 py-20 sm:px-8 sm:py-28"
    >
      <div className="mx-auto max-w-5xl">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="font-display mb-14 text-center text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
        >
          Built for how you teach. Built for how you learn.
        </motion.h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {audiences.map((a, i) => (
            <motion.div
              key={a.key}
              data-testid={`audience-card-${a.key}`}
              initial={{ opacity: 0, x: i === 0 ? -24 : 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-[28px] border border-slate-200/70 bg-white/80 p-8 shadow-[0_20px_50px_-20px_rgba(15,23,42,0.12)] backdrop-blur-sm"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-50 text-sky-600">
                <a.icon size={22} strokeWidth={2} />
              </div>
              <span className="font-mono-accent mt-6 block text-xs font-semibold uppercase tracking-[0.25em] text-sky-600">
                {a.label}
              </span>
              <h3 className="font-display mt-2 text-2xl font-bold text-slate-900">
                {a.title}
              </h3>
              <p className="font-body mt-3 text-base leading-relaxed text-slate-500">
                {a.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
